export interface SuperAdminAccount {
  account_type?: string | null;
  admin?: {
    is_super_admin?: boolean | null;
  } | null;
}

export function isSuperAdminAccount(
  account?: SuperAdminAccount | null
): boolean {
  return (
    account?.account_type === 'admin' && account.admin?.is_super_admin === true
  );
}
